module.exports = __webpack_public_path__ + "static/img/12.3149a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/12.jpg
// module id = u3WT
// module chunks = 15